// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","deltaUp":"_1AstenWQWfAw2eM4fLLMEj","deltaDown":"_3dg77KTMwPPYFlY6bsgyXB","deltaHolding":"_176NmQyrRTJziB8i2S7Az_"};